import { render } from "./index.vue?vue&type=template&id=c2957a7a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c2957a7a&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=c2957a7a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2957a7a"]])

export default __exports__